import React, { useEffect } from 'react';
import CONSTANTS from '../../../constants';
// import { useLocation } from 'react-router-dom';
const Air2Open = () => {
  // const location = useLocation();
  // useEffect(() => {
  //   if (window.location.hash) {
  //     setTimeout(() => {
  //       const el = document.getElementById(window.location.hash.replace('#', ''));
  //       if (el) el.scrollIntoView();
  //     }, 400); // 300ms 정도 지연
  //   }
  // }, [location]);
  return (
    <div id="air2open">
      <div className="top">
        <div className="area">
          <img src="https://img.dongascience.com/air/autopay/air2open_top.png" alt="과학동아AiR 새 옷입고 더 똑똑해졌어요!" />
        </div>
      </div>
      <div className="intro">
        <div className="area">
          <img src="https://img.dongascience.com/air/autopay/air2open_intro.png" alt="두둥! 저희AiR가 더 똑똑해졌어요!" />
          <button 
            type="button"
            style={{
              border: 'none',
              background: 'transparent',
              padding: 0,
              cursor: 'pointer'
            }}
            onClick={() => {
              window.open(CONSTANTS.D_LIBRARY_SUBSCRIPTION_PAYMENT, '_blank');
            }}
          >
            <img src="https://img.dongascience.com/air/autopay/air2open_intro_btn.png" alt="과학동아AiR ALL 패스권 특가 신청하기" />
          </button>
        </div>
      </div>
      <div className="info01">
        <div className="area">
          <img src="https://img.dongascience.com/air/autopay/autopay_info01.png" alt="과학동아AiR 강점" />
        </div>
      </div>
      <div className="info02">
        <div className="area">
          <img src="https://img.dongascience.com/air/autopay/air2open_info03.png" alt="과학동아AiR 활용방법" />
        </div>
      </div>
      {/* <div className="v2-link">
        <div className="area">
          <button 
            type="button"
            style={{
              border: 'none',
              background: 'transparent',
              padding: 0,
              cursor: 'pointer',
              width: '100%'
            }}
            onClick={() => {
              // v2.0 AiR로 이동하는 로직 (필요시 URL 수정)
              window.location.href = '/';
            }}
          >
            <img src="https://img.dongascience.com/air/autopay/air2open_new_btn.png" alt="새롭게 달라진 v2.0 과학동아AiR 바로가기" />
          </button>
        </div>
      </div> */}
      <div className="price">
        <div className="area">
          <img src="https://img.dongascience.com/air/autopay/air2open_price.png" alt="20% 초특가 할인" />
          <button 
            type="button"
            style={{
              border: 'none',
              background: 'transparent',
              padding: 0,
              cursor: 'pointer'
            }}
            onClick={() => {
              window.open(CONSTANTS.D_LIBRARY_SUBSCRIPTION_PAYMENT, '_blank');
            }}
          >
            <img src="https://img.dongascience.com/air/autopay/air2open_price_btn.png" alt="과학동아AiR 할인가로 만나보기" />
          </button>
        </div>
      </div>
      <div className="pogg">
        <div className="area">
          
          <img  id="pogg01" src="https://img.dongascience.com/air/autopay/pogg01.jpg" alt="만약 유독 회원이시라면? 더 많은 혜택을 누려보세요!" 
             onLoad={() => {
              if (window.location.hash === '#pogg01') {
                setTimeout(() => {
                  const el = document.getElementById('pogg01');
                  if (el) el.scrollIntoView({ behavior: 'auto', block: 'start' });
                }, 440);
              }
            }}/>
          <img src="https://img.dongascience.com/air/autopay/pogg02.jpg" alt="혜택1 과학공부 AI 풀세트" />
          <button
            type="button"
            style={{
              border: 'none',
              background: 'transparent',
              padding: 0,
              cursor: 'pointer'
            }}
            onClick={() => {
              // window.open('https://www.lguplus.com/pogg/product/유독-라이너-ai-pick', '_blank');
              window.open('https://www.lguplus.com/pogg/product/유독-라이너-더블-ai', '_blank');

            }}
          >
            <img src="https://img.dongascience.com/air/autopay/pogg03.jpg" alt="AI패키지 자세히 보러가기" />
          </button>
        
          <img id="pogg02" src="https://img.dongascience.com/air/autopay/pogg04.jpg" alt="혜택2 과학탐구 AI라이프 패키지" 
             onLoad={() => {
              if (window.location.hash === '#pogg02') {
                setTimeout(() => {
                  const el = document.getElementById('pogg02');
                  if (el) el.scrollIntoView({ behavior: 'auto', block: 'start' });
                }, 440);
              }
            }}/>
          <button
            type="button"
            style={{
              border: 'none',
              background: 'transparent',
              padding: 0,
              cursor: 'pointer'
            }}
            onClick={() => {
              window.open('https://www.lguplus.com/pogg/product/유독-과학동아-ai-pick', '_blank');
            }}
          >
            <img src="https://img.dongascience.com/air/autopay/pogg05.jpg" alt="과학동아AiR 라이프패키지 자세히 보러가기" />
          </button>
        </div>
      </div>
      
      {/* <div className="cs">
        <div className="area">
          <img src="https://img.dongascience.com/air/autopay/autopay_cs.png" alt="유의사항" />
        </div>
      </div> */}
    </div>
  );
};

export default Air2Open;
